import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentFuelFilterIdWithoutFallback } from '../../store/geoentity/fuels.selectors'
import { isStationServiceRubric } from '../../store/geoentity/geoentity.helpers'
import { selectGeoentities, selectIsWaitingForRequestedGeoentities } from '../../store/geoentity/geoentity.selectors'
import { selectCurrentHistoryRouteOptions } from '../../store/history/history.selectors'
import { isEqual } from '../../utils/lang'
import { pick } from '../../utils/object'
import { useScrollContext } from '../genericComponents/ResponsiveScrollableWrapper/ResponsiveScrollableWrapper'
import GeoentityFuelListItem from './GeoentityFuelListItem'
import GeoentityListItem from './GeoentityListItem'
import GeoentityListPlaceholder from './GeoentityListPlaceholder'
import GeoentityListStructuredData from './GeoentityListStructuredData'
import { searchFieldsForParams } from '../../store/history/history.constants'

const GeoentityList = ({
  noExternalButtons = false,
  geoentitiesSelector = selectGeoentities,
  seoHideImages = false
}) => {
  const isWaitingForGeoentities = useSelector(selectIsWaitingForRequestedGeoentities)
  const pois = useSelector(geoentitiesSelector)
  const scrollContext = useScrollContext()
  const [lastParams, setLastParams] = useState({})
  const currentParams = pick(useSelector(selectCurrentHistoryRouteOptions), searchFieldsForParams)

  useEffect(() => {
    if (__BROWSER__ && !isEqual(currentParams, lastParams)) {
      setLastParams(currentParams)
      scrollContext.scrollTop()
    }
  }, [currentParams, lastParams])

  const currentFuelFilterId = useSelector(selectCurrentFuelFilterIdWithoutFallback)
  if (currentFuelFilterId)
    pois.sort((a, b) =>
      a?.additionalInfo?.fuels?.find(({ id }) => id === currentFuelFilterId) &&
      !b?.additionalInfo?.fuels?.find(({ id }) => id === currentFuelFilterId)
        ? -1
        : 1
    )
  if (pois.length === 0 && isWaitingForGeoentities) return <GeoentityListPlaceholder />

  return (
    <ul>
      <GeoentityListStructuredData />
      {pois.map(poi =>
        isStationServiceRubric(poi?.rubric?.id) ? (
          <GeoentityFuelListItem
            key={poi.id}
            poi={poi}
            noExternalButtons={noExternalButtons}
            seoHideImages={seoHideImages}
          />
        ) : (
          <GeoentityListItem
            key={poi.id}
            poi={poi}
            noExternalButtons={noExternalButtons}
            seoHideImages={seoHideImages}
          />
        )
      )}
    </ul>
  )
}

export default GeoentityList
